import {
  CustomRole,
  CustomRoleResult,
  ListCustomRolesResponse,
  SaveCustomRoleRequest,
} from '@/client/custom-roles';
import { getExceptionFromAxiosError } from '@/client/helpers';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

export const customRolesService = (client: AxiosInstance) => {
  const baseUrl = (accountId: string) => `/accounts/${accountId}/custom-roles`;

  const getCustomRoles = async (
    accountId: string,
  ): Promise<ListCustomRolesResponse> => {
    try {
      const result = await client.get<
        ListCustomRolesResponse,
        AxiosResponse<ListCustomRolesResponse>
      >(baseUrl(accountId), { withCredentials: true });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const getCustomRole = async (
    accountId: string,
    id: string,
  ): Promise<CustomRoleResult> => {
    try {
      const result = await client.get<
        CustomRoleResult,
        AxiosResponse<CustomRoleResult>
      >(`${baseUrl(accountId)}/${id}`, { withCredentials: true });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const createCustomRole = async (
    accountId: string,
    payload: SaveCustomRoleRequest,
  ): Promise<CustomRole> => {
    try {
      const result = await client.post<CustomRole, AxiosResponse<CustomRole>>(
        baseUrl(accountId),
        payload,
        { withCredentials: true },
      );

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const updateCustomRole = async (
    accountId: string,
    id: string,
    payload: SaveCustomRoleRequest,
  ): Promise<CustomRole> => {
    try {
      const result = await client.patch<CustomRole, AxiosResponse<CustomRole>>(
        `${baseUrl(accountId)}/${id}`,
        payload,
        { withCredentials: true },
      );

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const deleteCustomRole = async (
    accountId: string,
    id: string,
  ): Promise<void> => {
    try {
      await client.delete(`${baseUrl(accountId)}/${id}`, {
        withCredentials: true,
      });
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return {
    getCustomRoles,
    getCustomRole,
    createCustomRole,
    updateCustomRole,
    deleteCustomRole,
  };
};
